import { render } from "./ReferrerFromAnalytics.vue?vue&type=template&id=d21c288a&scoped=true&ts=true&lang=pug"
import script from "./ReferrerFromAnalytics.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferrerFromAnalytics.vue?vue&type=script&lang=ts&setup=true"

import "./ReferrerFromAnalytics.vue?vue&type=style&index=0&id=d21c288a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21c288a"]])

export default __exports__